(function () {
  if (window.AxiomPickupAvailability) return;

  var pickupInstanceCount = 0;

  function normalizeShopifyId(value) {
    if (value === undefined || value === null) return '';
    var id = String(value).trim();
    var separatorIndex = id.lastIndexOf('/');
    return separatorIndex >= 0 ? id.slice(separatorIndex + 1) : id;
  }

  function getContainers(productId) {
    var selector = '[data-pickup-availability-container]';
    var containers = Array.prototype.slice.call(document.querySelectorAll(selector));
    var normalizedProductId = normalizeShopifyId(productId);
    if (!normalizedProductId) return containers;
    return containers.filter(function (container) {
      return normalizeShopifyId(container.dataset.productId) === normalizedProductId;
    });
  }

  function getEventContainers(event, productId) {
    var target = event && event.target;
    if (!target || target === document || !target.closest) return getContainers(productId);

    var owner = target.matches('[data-product-root], [data-featured-product-root]')
      ? target
      : target.closest('[data-product-root], [data-featured-product-root]');
    if (!owner) return getContainers(productId);

    var normalizedProductId = normalizeShopifyId(productId);
    return Array.prototype.slice.call(owner.querySelectorAll('[data-pickup-availability-container]')).filter(function (container) {
      return normalizeShopifyId(container.dataset.productId) === normalizedProductId;
    });
  }

  function getPickupLayer(container) {
    if (!container) return { drawer: null, overlay: null };

    var drawer = container.__pickupDrawer;
    var overlay = container.__pickupOverlay;
    if (!drawer || !drawer.isConnected) drawer = container.querySelector('[data-pickup-drawer]');
    if (!overlay || !overlay.isConnected) overlay = container.querySelector('[data-pickup-overlay]');

    container.__pickupDrawer = drawer || null;
    container.__pickupOverlay = overlay || null;
    if (drawer) drawer.__pickupContainer = container;
    if (overlay) overlay.__pickupContainer = container;

    return { drawer: drawer, overlay: overlay };
  }

  function getOwnerContainer(element) {
    if (!element) return null;
    var layer = element.closest('[data-pickup-drawer], [data-pickup-overlay]');
    if (layer && layer.__pickupContainer) return layer.__pickupContainer;
    return element.closest('[data-pickup-availability-container]');
  }

  function removePickupLayer(container) {
    var layer = getPickupLayer(container);
    var drawer = layer.drawer;
    var overlay = layer.overlay;
    var isOpen = drawer && (drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false');

    if (isOpen && window.Axiom && typeof window.Axiom.closeDrawer === 'function') {
      window.Axiom.closeDrawer(drawer, overlay);
    }
    if (drawer) drawer.remove();
    if (overlay) overlay.remove();

    container.__pickupDrawer = null;
    container.__pickupOverlay = null;
  }

  function syncContainerMeta(container) {
    var panel = container.querySelector('[data-pickup-panel]');
    var title = container.dataset.productTitle || '';
    var hasOnlyDefaultVariant = container.dataset.hasOnlyDefaultVariant === 'true';
    var multipleLabel = container.dataset.pickupMultipleLabel || '';
    var singleLabel = container.dataset.pickupSingleLabel || '';

    if (!panel) {
      container.hidden = true;
      return;
    }

    var productTitleEl = panel.querySelector('[data-pickup-product-title]');
    var variantTitleEl = panel.querySelector('[data-pickup-variant-title]');
    var openButton = panel.querySelector('[data-pickup-open]');
    var locationCount = parseInt(panel.dataset.pickupLocationCount || '0', 10) || 0;

    if (productTitleEl) productTitleEl.textContent = title;
    if (variantTitleEl) variantTitleEl.hidden = hasOnlyDefaultVariant || !variantTitleEl.textContent.trim();
    if (openButton) openButton.textContent = locationCount > 1 ? multipleLabel : singleLabel;

    var layer = getPickupLayer(container);
    var drawer = layer.drawer;
    var overlay = layer.overlay;
    if (!container.id) {
      pickupInstanceCount += 1;
      container.id = 'PickupAvailability-' + normalizeShopifyId(container.dataset.productId) + '-' + pickupInstanceCount;
    }
    if (drawer) {
      var drawerId = container.id + '-Drawer';
      var drawerTitleId = container.id + '-DrawerTitle';
      drawer.id = drawerId;
      drawer.hidden = true;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-labelledby', drawerTitleId);
      if (productTitleEl) productTitleEl.id = drawerTitleId;
      if (openButton) openButton.setAttribute('aria-controls', drawerId);
    }
    if (overlay) {
      overlay.hidden = true;
      overlay.classList.remove('is-open');
    }

    container.hidden = false;
  }

  function mountPickupLayer(container) {
    if (!container) return;
    var layer = getPickupLayer(container);
    var drawer = layer.drawer;
    var overlay = layer.overlay;
    if (!drawer || !overlay) return;

    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  }

  function updateContent(container, html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nextContent = doc.querySelector('[data-pickup-panel-section]');
    var currentContent = container.querySelector('[data-pickup-availability-content]');
    if (!currentContent) return false;

    removePickupLayer(container);
    currentContent.innerHTML = nextContent ? nextContent.innerHTML : '';
    container.__pickupFailedVariantId = '';
    syncContainerMeta(container);
    return true;
  }

  function renderErrorState(container, variantId) {
    if (!container) return;
    var normalizedVariantId = normalizeShopifyId(variantId);
    var currentContent = container.querySelector('[data-pickup-availability-content]');
    var errorTemplate = container.querySelector('template[data-pickup-error-template]');
    var errorContent = errorTemplate ? errorTemplate.content.cloneNode(true) : null;

    removePickupLayer(container);
    if (currentContent) {
      currentContent.innerHTML = '';
      if (errorContent) currentContent.appendChild(errorContent);
    }

    container.dataset.variantId = '';
    container.__pickupFailedVariantId = normalizedVariantId;
    var refreshButton = currentContent && currentContent.querySelector('[data-pickup-refresh]');
    if (refreshButton) refreshButton.dataset.variantId = normalizedVariantId;
    container.hidden = !currentContent || !errorContent;
  }

  function clearAvailability(container) {
    if (!container) return;
    if (container.__pickupAbortController) container.__pickupAbortController.abort();
    container.__pickupAbortController = null;
    container.__pickupRequestedVariantId = '';
    container.__pickupFailedVariantId = '';
    container.__pickupRequestToken = (container.__pickupRequestToken || 0) + 1;
    container.removeAttribute('aria-busy');
    removePickupLayer(container);

    var currentContent = container.querySelector('[data-pickup-availability-content]');
    if (currentContent) currentContent.innerHTML = '';
    container.dataset.variantId = '';
    container.hidden = true;
  }

  function fetchSection(container, variantId) {
    var normalizedVariantId = normalizeShopifyId(variantId);
    if (!container || !normalizedVariantId) return Promise.resolve();
    if (container.__pickupRequestedVariantId === normalizedVariantId) return Promise.resolve();
    if (normalizeShopifyId(container.dataset.variantId) === normalizedVariantId) {
      if (container.__pickupAbortController) {
        container.__pickupAbortController.abort();
        container.__pickupAbortController = null;
        container.__pickupRequestedVariantId = '';
        container.__pickupRequestToken = (container.__pickupRequestToken || 0) + 1;
        container.removeAttribute('aria-busy');
      }
      return Promise.resolve();
    }

    var sectionId = container.dataset.renderSectionId || 'pickup-availability-panel';
    var rootUrl = container.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var requestUrl = new URL(rootUrl, window.location.origin);
    requestUrl.pathname = requestUrl.pathname.replace(/\/?$/, '/') + 'variants/' + encodeURIComponent(normalizedVariantId) + '/';
    requestUrl.search = '';
    requestUrl.searchParams.set('section_id', sectionId);
    var requestToken = (container.__pickupRequestToken || 0) + 1;
    container.__pickupRequestToken = requestToken;
    if (container.__pickupAbortController) container.__pickupAbortController.abort();
    container.__pickupAbortController = new AbortController();
    container.__pickupRequestedVariantId = normalizedVariantId;
    container.setAttribute('aria-busy', 'true');

    return fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      signal: container.__pickupAbortController.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load pickup availability section');
        return response.text();
      })
      .then(function (html) {
        if (container.__pickupRequestToken !== requestToken) return;
        if (updateContent(container, html)) {
          container.dataset.variantId = normalizedVariantId;
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        if (container.__pickupRequestToken !== requestToken) return;
        renderErrorState(container, normalizedVariantId);
        console.error(error);
      })
      .finally(function () {
        if (container.__pickupRequestToken === requestToken) {
          container.__pickupAbortController = null;
          container.__pickupRequestedVariantId = '';
          container.removeAttribute('aria-busy');
        }
      });
  }

  function openPickupDrawer(container) {
    if (!container || !window.Axiom || typeof window.Axiom.openDrawer !== 'function') return;
    var trigger = container.querySelector('[data-pickup-open]');
    var layer = getPickupLayer(container);
    var drawer = layer.drawer;
    var overlay = layer.overlay;
    if (!drawer || !overlay) return;
    mountPickupLayer(container);
    window.Axiom.openDrawer(drawer, overlay, {
      trapFocus: true,
      autofocus: true,
      focusTarget: drawer.querySelector('[data-pickup-close]'),
      returnFocus: trigger
    });
  }

  function closePickupDrawer(container) {
    if (!container || !window.Axiom || typeof window.Axiom.closeDrawer !== 'function') return;
    var layer = getPickupLayer(container);
    var drawer = layer.drawer;
    var overlay = layer.overlay;
    if (!drawer || !overlay) return;
    window.Axiom.closeDrawer(drawer, overlay);
  }

  function initContainers(scope) {
    var containers = scope && scope.querySelectorAll
      ? Array.prototype.slice.call(scope.querySelectorAll('[data-pickup-availability-container]'))
      : getContainers();

    containers.forEach(function (container) {
      syncContainerMeta(container);
    });
  }

  document.addEventListener('shopify:product:select', function (event) {
    if (!event.promise) return;
    var productId = normalizeShopifyId(event.product && event.product.id);
    if (!productId) return;
    var containers = getEventContainers(event, productId);
    event.promise.then(function (result) {
      var variant = result && result.variant;
      var variantId = normalizeShopifyId(variant && variant.id);
      if (!variantId || variant.availableForSale === false) {
        containers.forEach(clearAvailability);
        return;
      }
      containers.forEach(function (container) {
        fetchSection(container, variantId);
      });
    }).catch(function () {});
  });

  document.addEventListener('click', function (event) {
    var refreshButton = event.target.closest('[data-pickup-refresh]');
    if (refreshButton) {
      event.preventDefault();
      var refreshContainer = refreshButton.closest('[data-pickup-availability-container]');
      var failedVariantId = normalizeShopifyId(
        refreshButton.dataset.variantId || (refreshContainer && refreshContainer.__pickupFailedVariantId)
      );
      if (refreshContainer && failedVariantId) fetchSection(refreshContainer, failedVariantId);
      return;
    }

    var openButton = event.target.closest('[data-pickup-open]');
    if (openButton) {
      event.preventDefault();
      openPickupDrawer(openButton.closest('[data-pickup-availability-container]'));
      return;
    }

    var closeButton = event.target.closest('[data-pickup-close]');
    if (closeButton) {
      event.preventDefault();
      closePickupDrawer(getOwnerContainer(closeButton));
      return;
    }

    var overlay = event.target.closest('[data-pickup-overlay]');
    if (overlay) {
      event.preventDefault();
      closePickupDrawer(getOwnerContainer(overlay));
    }
  });

  initContainers(document);
  document.addEventListener('shopify:section:load', function (event) {
    initContainers(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-pickup-availability-container]').forEach(function (container) {
      if (container.__pickupAbortController) container.__pickupAbortController.abort();
      removePickupLayer(container);
    });
  });

  window.AxiomPickupAvailability = {
    initContainers: initContainers,
    fetchSection: fetchSection
  };
})();
